// extracted by mini-css-extract-plugin
module.exports = {"selectionGroup":"AcsQkb7","selectionItem":"E2E38Xu"};